import _ from 'lodash'
import React, { useState } from 'react'
import {
  PreviewSkeletonType
  // SkeletonConfigType
} from 'src/lib/types/uiPreview'
import Pill from './Pill'

interface LoadingDiscountListProps {
  primaryColor: string
  primaryTextColor: string
  length: number
  skeleton: PreviewSkeletonType
}

const LoadingDiscountList: React.FC<LoadingDiscountListProps> = ({
  primaryColor,
  primaryTextColor,
  length,
  skeleton
}) => {
  return (
    <>
      {_.times(length, (index: number) => {
        return (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: skeleton.layout,
              padding: '1rem',
              width: '100%',
              border: index === 0 ? `2px solid ${primaryColor}` : '1px solid #F0F0F0',
              borderRadius: '16px',
              gap: 6,
              position: 'relative'
            }}
          >
            {skeleton?.config?.map((item: any, index: number) => {
              return <Pill height={item?.height} width={item?.width} key={index} />
            })}
            {index === 0 ? (
              <div
                className={`absolute top-2 right-2 h-10 w-20 rounded-3xl rounded-tr-lg flex items-center justify-center`}
                style={{ background: primaryColor }}
              >
                <span className='font-bold text-sm' style={{ color: primaryTextColor }}>
                  Apply
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>
        )
      })}
    </>
  )
}

export default LoadingDiscountList
